var map = {
	"./desktop/selectFolder": "./framework/src/config/staticViews/desktop/selectFolder.json",
	"./desktop/selectFolder.json": "./framework/src/config/staticViews/desktop/selectFolder.json",
	"./desktop/uploadList": "./framework/src/config/staticViews/desktop/uploadList.json",
	"./desktop/uploadList.json": "./framework/src/config/staticViews/desktop/uploadList.json",
	"./phone/selectFolder": "./framework/src/config/staticViews/phone/selectFolder.json",
	"./phone/selectFolder.json": "./framework/src/config/staticViews/phone/selectFolder.json",
	"./phone/uploadList": "./framework/src/config/staticViews/phone/uploadList.json",
	"./phone/uploadList.json": "./framework/src/config/staticViews/phone/uploadList.json",
	"./tablet/selectFolder": "./framework/src/config/staticViews/tablet/selectFolder.json",
	"./tablet/selectFolder.json": "./framework/src/config/staticViews/tablet/selectFolder.json",
	"./tablet/uploadList": "./framework/src/config/staticViews/tablet/uploadList.json",
	"./tablet/uploadList.json": "./framework/src/config/staticViews/tablet/uploadList.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./framework/src/config/staticViews sync recursive ^\\.\\/.*$";